import { create } from 'zustand'
import { getBaseTime5Min } from '@utils/getTime.js'

const init = {
  serverTime: null,
  storedAt: null,
  baseTime: null
}
export const useTimeStore = create((set, get) => ({
  ...init,
  setServerTime: (serverTimeRaw) => {
    const parsed = new Date(serverTimeRaw?.serverTime)
    if (!serverTimeRaw || isNaN(parsed.getTime())) {
      return
    }
    set({
      serverTime: parsed,
      storedAt: Date.now()
    })
  },
  getBaseTime: () => {
    const { serverTime, storedAt } = get()
    if (!serverTime) return new Date()
    const diff = Date.now() - storedAt
    return new Date(serverTime.getTime() + diff)
  },
  updateBaseTime: () => {
    const now = get().getBaseTime()
    const base = getBaseTime5Min(now)
    set({ baseTime: base })
  }
}))